<template>
  <UPageSection
    v-if="items.length"
    :title="title"
    :ui="{
      title: 'text-2xl font-bold sm:text-3xl',
      container: 'py-10 sm:py-12 bg-muted/20 rounded-2xl',
    }"
  >
    <div class="grid items-stretch gap-5 md:grid-cols-2">
      <UPageCard
        v-for="(reason, index) in items"
        :key="index"
        variant="subtle"
        class="h-full"
        :ui="{ container: 'gap-3' }"
      >
        <div class="flex items-start gap-3">
          <span
            class="flex size-9 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-bold text-white"
            aria-hidden="true"
          >
            {{ index + 1 }}
          </span>
          <div class="min-w-0 flex-1 space-y-2">
            <h3 class="line-clamp-2 min-h-14 text-lg font-semibold leading-7 text-highlighted">
              {{ reason.title }}
            </h3>
            <p class="line-clamp-3 min-h-[4.5rem] text-sm leading-6 text-muted">
              {{ reason.description }}
            </p>
            <ul v-if="reason.points?.length" class="space-y-2 pt-1">
              <li
                v-for="(point, pointIndex) in reason.points"
                :key="pointIndex"
                class="flex gap-2 text-sm text-muted"
              >
                <UIcon name="i-heroicons-check" class="mt-0.5 size-4 shrink-0 text-primary" />
                <span>{{ pointText(point) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </UPageCard>
    </div>
  </UPageSection>
</template>

<script setup lang="ts">
export type ReasonItem = {
  title?: string
  description?: string
  points?: Array<string | { text?: string }>
}

withDefaults(
  defineProps<{
    title?: string
    items?: ReasonItem[]
  }>(),
  {
    items: () => [],
  },
)

function pointText(point: string | { text?: string } | Record<string, string>): string {
  if (typeof point === 'string') return point
  if (point && typeof point === 'object' && 'text' in point && point.text) return String(point.text)
  if (point && typeof point === 'object') {
    const values = Object.values(point).filter((v) => typeof v === 'string')
    return values[0] ?? ''
  }
  return ''
}
</script>
